import * as React from 'react';
import styled from 'styled-components';
import { FlexBox } from '@agilepoint/wat-react-ux';
import { HelpLink, IHelpLinkProps } from './help-link';

const HelpIconWrapper = styled(FlexBox) <{ helpLinkPosition: 'left' | 'right' }>`
     width:100%;
     justify-content: ${({ helpLinkPosition }) => (helpLinkPosition === 'left' ? 'flex-start' : 'flex-end')};
     box-sizing: border-box;
 `;

const ReportsHelpIconWrapper = styled.div`
    position: absolute;
    top: 315px;
    right: 24px;
    z-index: 10;
`;

const DefaultAppSettingsHelpIconWrapper = styled.div`
    position: absolute;
    top: 40px;
    right: 30px;
    z-index: 10;
`;

const MobileAppHelpIconWrapper = styled.div`
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 10;
`;

interface IHelpLinkPositionProps extends IHelpLinkProps {
    helpLinkPosition?: 'left' | 'right';
}

export const PositionedHelplink = React.memo((prop: IHelpLinkPositionProps) => {
    const { helpLinkPosition = 'right', ...rest } = prop;

    return (
        <HelpIconWrapper helpLinkPosition={helpLinkPosition}>
            <HelpLink {...rest} />
        </HelpIconWrapper>
    );
});

export const ReportsTabHelplink = React.memo((props: IHelpLinkProps) => (
    <ReportsHelpIconWrapper>
        <HelpLink {...props} />
    </ReportsHelpIconWrapper>
));

export const DefaultAppSettingsTabHelplink = React.memo((props: IHelpLinkProps) => (
    <DefaultAppSettingsHelpIconWrapper>
        <HelpLink {...props} />
    </DefaultAppSettingsHelpIconWrapper>
));

export const MobileAppHelpLink = React.memo((props: IHelpLinkProps) => (
    <MobileAppHelpIconWrapper>
        <HelpLink {...props} />
    </MobileAppHelpIconWrapper>
));
